import * as types from '../actions/types';

const INITIAL_STATE = {
  error: '',
  list: [],
  totalAmountOfDocumentTypes: 0,
  documentTypesPerPage: 10,
  fetching: false,
  showModal: false,
  addDocumentTypesError: '',
  addDocumentTypesFetching: false,
  typeAheadResults: [],
  typeAheadError: '',
  typeAheadFetching: false,
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.SET_FETCHING_DOCUMENT_TYPES_SETTINGS:
      return { ...state, fetching: true, list: [], error: '' };
    case types.SET_DOCUMENT_TYPES_SETTINGS_ERROR:
      return { ...state, error: action.payload, fetching: false };
    case types.SET_DOCUMENT_TYPES_SETTINGS_LIST:
      return { ...state, list: action.payload, fetching: false };
    case types.SET_TOTAL_AMOUNT_OF_DOCUMENT_TYPES_SETTINGS:
      return { ...state, totalAmountOfDocumentTypes: action.payload };
    case types.SET_DOCUMENT_TYPES_SETTINGS_SHOW_MODAL:
      return { ...state, showModal: action.payload };
    case types.SET_DOCUMENT_TYPES_SETTINGS_ADD_FETCHING:
      return { ...state, addDocumentTypesFetching: true, addDocumentTypesError: '' };
    case types.SET_DOCUMENT_TYPES_SETTINGS_ADD_SUCCESS:
      return { ...state, addDocumentTypesFetching: false };
    case types.SET_DOCUMENT_TYPES_SETTINGS_ADD_ERROR:
      return { ...state, addDocumentTypesFetching: false, addDocumentTypesError: action.payload };
    default:
      return state;
  }
};
